export const notificationsRoute = '/enterprise/notifications/';
export const notificationReadRoute = '/notifications/read/';
